<template>
  <Modal
    @close="$emit('close')"
    :width="onlySearch ? '496px' : '781px'"
    :height="onlySearch ? '558px' : '415px'"
    padding="25px 0 0"
  >
    <h2 style="margin-bottom: 24px; text-align: center">
      Добавление пассажира
    </h2>
    <div
      class="user__modal scroll"
      :style="{ margin: onlySearch ? '0 14px 0 32px' : '0 34px 0 47px' }"
    >
      <!-- пользователь -->
      <Form
        class="gap"
        style="margin-bottom: 32px"
        v-model="userData"
        ref="userData"
        scrollWhenInvalid
      >
        <h3>Сотрудник ГТТ</h3>
        <VSelect
          placeholder="Найти сотрудника ГТТ"
          style="margin-bottom: 6px"
          name="user"
          :items="usersWithFIO"
          search="FIO"
          :required="onlySearch"
          is-gtt
          with-button
          :is-auto-search="false"
          @change="setUser"
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge :user="item" />
          </template>
        </VSelect>
      </Form>

      <!-- пассажир -->
      <Form
        class="gap"
        v-for="(data, i) in passengersData"
        :key="i + 'pasData'"
        ref="passengers"
        scrollWhenInvalid
        :value="data"
        style="margin-bottom: 32px"
      >
        <h3>Не сотрудник ГТТ</h3>
        <VSelect
          placeholder="Найти не сотрудника ГТТ"
          name="passenger"
          :items="passengersWithFIO"
          search="FIO"
          is-no-gtt
          with-button
          :is-auto-search="false"
          @change="(passenger) => setPassenger(passenger, i)"
          style="margin-bottom: 6px"
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge :user="item" />
          </template>
        </VSelect>
      </Form>
    </div>

    <div :class="['control', { small: onlySearch, big: !onlySearch }]">
      <Button
        :width="onlySearch ? '100%' : '250px'"
        height="48px"
        text="Не сотрудник ГТТ"
        icon="add"
        iconWidth="20px"
        class="btn-outline-primary"
        @click="passengersData.push({}); selectedDocTypes.push(null)"
      />

      <div class="control__confrim">
        <Button
          :width="onlySearch ? '100%' : '163px'"
          height="48px"
          text="Добавить"
          :loading="addPassengerLoading"
          class="btn-primary"
          @click="setAllPassengers"
        />
        <Button
          @click.native.prevent="$emit('close')"
          :width="onlySearch ? '100%' : '163px'"
          height="48px"
          text="Отменить"
          class="btn-secondary"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modals/Modal.vue";
import AccountBadge from "@/components/AccountBadge.vue";

import { getDepartment } from "@/api/departments";
import { mapState, mapMutations, mapGetters } from "vuex";
import { simpleDate } from "@/utils/filters/dateFilters";
import { getPassengerWithoutDepartament } from "@/api/users";

export default {
  components: {
    Form,
    VSelect,
    Button,
    Modal,
    AccountBadge,
  },
  props: {
    usersWithFIO: {
      type: Array,
      default: () => [],
    },
    onlySearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userData: {},
      passengersData: [],
      addPassengerLoading: false,
      selectedDocTypes: [],
      passengersByDepartment: null,

      passenger: []
    };
  },
  async mounted() {
    if (this.onlySearch) {
      this.passengersData.push({});
      this.selectedDocTypes.push(null);
    }

    const { data } = await getPassengerWithoutDepartament()
    this.passenger = data.data || []
  },
  methods: {
    ...mapMutations("users", ["ADD_PASSENGER", "ADD_USER"]),
    async setAllPassengers() {

      this.addPassengerLoading = true;

      if (this.userData.user) {
        this.$emit("add", this.userData)
      }

      // если выбран существующий пассажир
      if (this.passengersData.length > 0) {
        for (let index = 0; index < this.passengersData?.length; index++) {
          if (this.passengersData[index].id) {
            this.$emit("add", this.passengersData[index])
          }
        }
      }

      this.addPassengerLoading = false;
      this.$emit("close");
    },
    setUser(user) {
      if (user) {
        this.userData = {
          ...user,
          docType: this.documentTypes.find(
            (doc) => doc.id === user.document?.id
          ),
          docNumber: user.document_number,
          docValid: user.document_validity
            ? simpleDate(user.document_validity)
            : null,
          department: this.getDepartmentById(user.department_id),
          sex: { value: user.sex, name: user.sex ? "Женщина" : "Мужчина" },
        };

        if (user.department_id) {
          getDepartment(user.department_id, "passengers").then(
            (res) => (this.passengersByDepartment = res.data.passengers || null)
          );
        } else {
          this.passengersByDepartment = null;
        }
      } else {
        this.userData = {};
        this.passengersByDepartment = null;
      }
    },
    setPassenger(passenger, index) {
      if (passenger) {
        const {
          name,
          surname,
          patronymic,
          sex,
          document_number,
          document_id,
          document_validity,
          birthday,
        } = passenger;

        this.$set(this.passengersData, index, {
          ...passenger,
          passenger,
          pasName: name,
          pasSurname: surname,
          pasPatronymic: patronymic,
          sex: { value: sex, name: sex ? "Женщина" : "Мужчина" },
          docNumber: document_number,
          docType: this.documentTypes.find((doc) => doc.id === document_id),
          docValid: simpleDate(document_validity),
          birthday: simpleDate(birthday),
        });
      } else {
        this.$set(this.passengersData, index, {});
      }
    },
  },
  computed: {
    ...mapState("options", ["documentTypes", "sexOption"]),
    ...mapState("departments", ["departments"]),
    ...mapState("filiations", ["filiations"]),
    ...mapGetters("departments", ["getDepartmentById"]),

    passengersWithFIO() {
      return this.passenger.map(
        (passenger) => {
          return {
            FIO: `${passenger.surname || ""} ${passenger.name || ""} ${
              passenger.patronymic || ""
            }`,
            ...passenger,
          };
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.user__modal {
  height: 479px;
  width: auto;
}

.gap {
  display: grid;
  row-gap: 12px;

  &.two__col {
    grid-template-columns: 1fr 1fr;
    column-gap: 14px;
  }
}

.control {
  display: flex;
  margin-top: auto;

  &.small {
    flex-direction: column;
    row-gap: 32px;
    padding: 0 32px 43px;

    .control__confrim {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
    }
  }

  &.big {
    justify-content: space-between;
    background: #f7f9f9;
    padding: 25px 47px;

    .control__confrim {
      display: flex;
      column-gap: 8px;
    }
  }
}
</style>
